import React from "react";
import Fade from "react-reveal/Fade";

class QuickServices extends React.Component {
  render() {
    return (
      <Fade bottom>
        <div className="quickServicesContainer">
          <div className="quickServicesContent">
            <div className="quickServicesIconContainer">
              <span className="iconFlat flaticon-tray"></span>
            </div>
            <div>
              <h2 className="heading2">Quality Service</h2>
            </div>
            <div>
              <p className="descriptionText2">
                Excepteur sint occaecat, sunt in cul qui. Hello there !
              </p>
            </div>
          </div>
          <div className="quickServicesContent">
            <div className="quickServicesIconContainer">
              <span className="iconFlat flaticon-soup"></span>
            </div>
            <div>
              <h2 className="heading2">Delicious Food</h2>
            </div>
            <div>
              <p className="descriptionText2">
                Excepteur sint occaecat, sunt in cul qui. Hello there !
              </p>
            </div>
          </div>
          <div className="quickServicesContent">
            <div className="quickServicesIconContainer">
              <span className="iconFlat flaticon-pancake"></span>
            </div>
            <div>
              <h2 className="heading2">Friendly Staff</h2>
            </div>
            <div>
              <p className="descriptionText2">
                Excepteur sint occaecat, sunt in cul qui. Hello there !
              </p>
            </div>
          </div>
          <div className="quickServicesContent">
            <div className="quickServicesIconContainer">
              <span className="iconFlat icon-phone3"></span>
            </div>
            <div>
              <h2 className="heading2">Easy Reservation</h2>
            </div>
            <div>
              <p className="descriptionText2">
                Excepteur sint occaecat, sunt in cul qui. Hello there !
              </p>
            </div>
          </div>
        </div>
      </Fade>
    );
  }
}

export default QuickServices;
